import { FC, PropsWithChildren } from "react";
import styles from "./styles.module.css";
import { Typography } from "@mui/material";
import clsx from "clsx";
// import AttentionIcon from "./AttentionIcon";

interface TextErrorProps {
  className?: string;
}

const TextError: FC<PropsWithChildren<TextErrorProps>> = ({
  children,
  className,
}) => {
  return (
    <Typography className={clsx(styles.error, className)}>
      {/* <AttentionIcon
        size={16}
        sx={{
          color: "var(--color-text-error)",
        }}
      /> */}
      {children}
    </Typography>
  );
};

export default TextError;
